import React, { useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_ACTIVATE_URL } from '../constants';

const ActivateUser: React.FC = () => {

    const { actionGuid } = useParams();
    const navigate = useNavigate();
    const isNavigated = useRef(false);

    useEffect(() => {
        const activateUser = async (retries = 3) => {
            if (!actionGuid) return;

            try {
                await axios.post(
                    API_ACTIVATE_URL,
                    { ActionId: actionGuid.toUpperCase() },
                    { headers: { 'Content-Type': 'application/json' } }
                );

                if (!isNavigated.current) {
                    isNavigated.current = true; // Mark as navigated
                    navigate('/login', {
                        state: {
                            message: 'Ihr Account wurde erfolgreich aktiviert. Bitte melden Sie sich an.',
                            type: 'success'
                        }
                    });
                }
            } catch (error) {
                if (retries > 0) {
                    setTimeout(() => activateUser(retries - 1), 1000); // Retry after 1 second
                } else {
                    if (!isNavigated.current) {
                        isNavigated.current = true; // Mark as navigated
                        navigate('/register', {
                            state: {
                                message: 'Die Aktivierung des Accounts ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
                                type: 'error'
                            }
                        });
                    }
                }
            }
        };

        activateUser();
    }, [actionGuid, navigate]);


    return (
        <>

        </>
    );

}

export default ActivateUser;